define('services/SpaceService',['require','lib/backbone/Backbone.Mixins.Transport.API','jquery'],function(require) {

  var API = require('lib/backbone/Backbone.Mixins.Transport.API');
  var jQuery = require('jquery');

  return {
    createSpace: function(attributes) {
      return API.request('POST', '/space/', attributes);
    },

    createSpaceWithShare: function(attributes, shareId) {
      var dfd = jQuery.Deferred();

      // Find share
      API.request('GET', '/app_store/{0}/v2'.format(shareId)).done(function(response) {

        // Create space
        API.request('POST', '/space/', attributes).done(function(response) {

          // Install share on new space
          API.request('POST', '/app_store/{0}/install/v2'.format(shareId), {
            space_id: response.space_id,
            dependencies: null,
            social: false
          }).always(function() {
            dfd.resolve(response);
          });

        }).fail(function() {
          dfd.reject();
        });
      }).fail(function() {
        dfd.reject();
      });

      return dfd;
    }
  };
});

